import React from "react";
import { CMApp, Sidebar } from "cm-layout";
import { SubstateClaimReader, CadmakersApp, AppSubState } from "@cadmakers/auth";
import { useLoggedInUser } from "../../../Auth";
import { AppSubscriptionClaimType } from "../../../App/Constants/authConstants";

type AppLinkData = { key: string; app: any; disabled?: boolean };

export const SidebarAppLinks = () => {
  const user = useLoggedInUser();

  const isAppSubValid = (app: CadmakersApp) => {
    if (!user) {
      return false;
    }

    const subStateClaimReader = new SubstateClaimReader(user.profile[AppSubscriptionClaimType]);

    const subscription = subStateClaimReader.getSubscription(app);

    switch (subscription) {
      case AppSubState.CMActiveDirectory:
        return true;
      case AppSubState.Trial:
        return true;
      case AppSubState.Paid:
        return true;
      case AppSubState.Guest:
        return true;
      default:
        return false;
    }
  };

  const getLoggedInUserApps = () => {
    const appList: AppLinkData[] = [];

    appList.push({
      key: "knowledge",
      app: CMApp.CMKnowledge,
      disabled: !isAppSubValid(CadmakersApp.Knowledge)
    });

    appList.push({
      key: "exe",
      app: CMApp.CMExe,
      disabled: !isAppSubValid(CadmakersApp.Exe)
    });

    appList.push({
      key: "builder",
      app: CMApp.CMBuilder,
      disabled: !isAppSubValid(CadmakersApp.Builder)
    });

    appList.push({
      key: "feedback",
      app: CMApp.CMFeedback
    });

    return appList;
  };

  if (!user) {
    return null;
  }

  return (
    <>
      {getLoggedInUserApps().map((appData: AppLinkData) => {
        return (
          <Sidebar.AppMenuItem key={appData.key} app={appData.app} disabled={appData.disabled} />
        );
      })}
    </>
  );
};
